import * as React from 'react';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/src/components/ui/dialog';
import { Button } from '@/src/components/ui/button';

interface UpgradeModalProps {
  open: boolean;
  message: string;
  onUpgrade: () => void;
  onStay: () => void;
}

export function UpgradeModal({
  open,
  message,
  onUpgrade,
  onStay
}: UpgradeModalProps) {
  return (
    <Dialog open={open} onOpenChange={() => onStay()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Upgrade Required</DialogTitle>
        </DialogHeader>
        <div className='py-4 text-base text-gray-700'>{message}</div>
        <DialogFooter>
          <Button variant='outline' onClick={onStay}>
            Stay Here
          </Button>
          <Button variant='default' onClick={onUpgrade}>
            Upgrade
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
